export default "__VITE_ASSET__80X93e_X__"